export default __webpack_public_path__ + "static/media/password-changed-lock.446ff5d2.svg";